import * as tslib_1 from "tslib";
import React, { useCallback, useState, useEffect, useMemo, useRef } from 'react';
import { isFieldValueFilled } from '../../hooks';
import { FloatingLabel } from '../basic';
import { LocalizeButton as Button } from '../';
export const TextboxInput = (_a) => {
    var { type, value, label, placeholder, error, onfocus, onblur, onchange, autoFocus, allowUnmask, preventPaste, prefix, controlledLabel, onLabelStateChange, disabled, defaultLabelId, labelPrefix, children } = _a, rest = tslib_1.__rest(_a, ["type", "value", "label", "placeholder", "error", "onfocus", "onblur", "onchange", "autoFocus", "allowUnmask", "preventPaste", "prefix", "controlledLabel", "onLabelStateChange", "disabled", "defaultLabelId", "labelPrefix", "children"]);
    const { name } = rest;
    const inputRef = useRef();
    const [inputValue, setInputValue] = useState();
    const val = inputValue || value;
    const [maskPassword, setMaskPassword] = useState(true);
    const [floatingLabelState, setFloatingLabelState] = useState({
        isFilled: isFieldValueFilled(val),
    });
    const updateFloatingLabelState = useCallback((state) => {
        setFloatingLabelState(state);
        if (onLabelStateChange) {
            onLabelStateChange(state);
        }
    }, [onLabelStateChange]);
    const onFocus = useCallback((e) => {
        if (onfocus) {
            onfocus(e);
        }
        updateFloatingLabelState({
            isFilled: true,
            hasFocus: true,
        });
    }, [onfocus, updateFloatingLabelState]);
    const onBlur = useCallback((e) => {
        if (onblur) {
            onblur(e);
        }
        updateFloatingLabelState({
            isFilled: isFieldValueFilled(e.target.value),
            hasFocus: false,
        });
    }, [onblur, updateFloatingLabelState]);
    const onChange = useCallback((e) => {
        const rawValue = e.target.value;
        const val = type === 'number' ? parseFloat(rawValue) : rawValue;
        if (onchange) {
            onchange(e, val);
        }
        else {
            setInputValue(rawValue);
        }
        updateFloatingLabelState({
            isFilled: isFieldValueFilled(val),
            hasFocus: floatingLabelState.hasFocus,
        });
    }, [type, onchange, updateFloatingLabelState, floatingLabelState.hasFocus]);
    const onPaste = useCallback((e) => {
        if (preventPaste) {
            e.preventDefault();
        }
    }, [preventPaste]);
    const onDragDrop = useCallback((e) => {
        if (preventPaste) {
            e.preventDefault();
        }
    }, [preventPaste]);
    useEffect(() => {
        if (autoFocus) {
            setTimeout(() => {
                if (inputRef && inputRef.current) {
                    inputRef.current.focus();
                    window.setTimeout(onFocus, 10);
                }
            }, 100);
        }
    }, [autoFocus, onFocus]);
    useEffect(() => {
        if (!controlledLabel) {
            updateFloatingLabelState({
                isFilled: isFieldValueFilled(val),
                hasFocus: floatingLabelState.hasFocus,
            });
        }
    }, [val, controlledLabel, floatingLabelState.hasFocus, updateFloatingLabelState]);
    const icon = useMemo(() => {
        if (type === 'password' && allowUnmask) {
            return (React.createElement(Button, { type: maskPassword ? 'show' : 'hide', onClick: () => setMaskPassword(!maskPassword), tabIndex: -1 },
                React.createElement("i", { className: `fal fa-lg ${maskPassword ? 'fa-lock-alt' : 'fa-lock-open-alt'}` })));
        }
        return undefined;
    }, [type, maskPassword, allowUnmask]);
    const fieldType = useMemo(() => {
        if (type === 'number') {
            return type;
        }
        if (!maskPassword) {
            return 'text';
        }
        return type;
    }, [maskPassword, type]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FloatingLabel, { id: name, className: error ? 'invalid' : '', label: placeholder || label || name, prefix: prefix, icon: icon, state: floatingLabelState, disabled: disabled },
            React.createElement("input", Object.assign({ ref: inputRef, className: "flabel-input", id: name, type: fieldType, value: isFieldValueFilled(val) ? val : '', disabled: disabled, onFocus: onFocus, onBlur: onBlur, onChange: onChange, onPaste: onPaste, onDrag: onDragDrop, onDrop: onDragDrop, autoComplete: name }, rest)))));
};
//# sourceMappingURL=Textbox.js.map